import { ErrorLayout } from './ErrorLayout';

export function AppErrorMaintenance() {
  return (
    <ErrorLayout title="We are upgrading.">
      <p className="text-2xl font-bold">We are in the middle of updating InScope. Please return in a few minutes.</p>
    </ErrorLayout>
  );
}
